import { render, staticRenderFns } from "./DetaillNow.vue?vue&type=template&id=a2d262fa&scoped=true&"
import script from "./DetaillNow.vue?vue&type=script&lang=js&"
export * from "./DetaillNow.vue?vue&type=script&lang=js&"
import style0 from "./DetaillNow.vue?vue&type=style&index=0&id=a2d262fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d262fa",
  null
  
)

export default component.exports